<ul class="key-value-collection--base">
  <li *ngFor="let row of collection" class="key-value-collection--row">
    <p
      class="key-value-collection--key key-value-collection--key-width-{{
        keyColumnWidth
      }}"
    >
      {{ row.key | translate }}
    </p>
    <p class="key-value-collection--value">{{ row.value | translate }}</p>
  </li>
</ul>
